import { generatedApi } from './api.generated';
import { createEndpointExports, createHookExports } from '@skynet/data-helpers';
import type { HookExports } from '@skynet/data-helpers';
import { DEX_AGENT_API_ENDPOINTS as cfg } from './config';

// The API exposes mutations only and none provide or invalidate tags, so there
// is nothing to enhance.
export const dexAgentApi: typeof generatedApi = generatedApi;

export const hookExports: HookExports<typeof cfg, typeof dexAgentApi> = createHookExports(
  cfg,
  dexAgentApi,
);

const endpointExports = createEndpointExports(cfg, dexAgentApi);

export const dexAgentApiEndpoints: typeof endpointExports = endpointExports;
